import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    top: {
        display: "flex",
        minWidth: "100%",
        justifyContent: "flex-end",
        height: "50px",
        alignItems: "center",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "34px",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
    },
    title: {
        fontSize: "28px",
        fontWeight: 800,
        color: "#F21C62",
        textAlign: "center",
    },
    description: {
        fontSize: "14px",
        fontWeight: 400,
        color: "#333333",
        textAlign: "center",
        padding: "0 30px",
    },
    button: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        padding: "16px",
        height: "60px",
        fontSize: "16px",
        fontWeight: 500,
        color: "#000",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow:
            "none",
        borderRadius: "30px",
        backgroundColor: "#52EB58",

        "&:hover": {
            boxShadow: "none !important",
            backgroundColor: "#52EB58 !important",
        },
    },
    image: {
        width: "70%",
        height: "auto",
    },
    whatsAppButton: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        color: "#6DC89E",
        cursor: "pointer",
        fontWeight: 500,
    },
    buttonContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "28px",
        width: "100%",
        padding: "20px 0px",
    },
}));